/**
 * Base class for Supabase-related errors
 */
export class SupabaseError extends Error {
  code: string;
  context?: Record<string, unknown>;

  constructor(message: string, code: string, context?: Record<string, unknown>) {
    super(message);
    this.name = 'SupabaseError';
    this.code = code;
    this.context = context;
  }
}

/**
 * Error thrown when authentication operations fail
 */
export class AuthError extends SupabaseError {
  constructor(message: string, context?: Record<string, unknown>) {
    super(message, 'AUTH_ERROR', context);
    this.name = 'AuthError';
  }
}

/**
 * Error thrown when database operations fail
 */
export class DatabaseError extends SupabaseError {
  constructor(message: string, context?: Record<string, unknown>) {
    super(message, 'DATABASE_ERROR', context);
    this.name = 'DatabaseError';
  }
}

/**
 * Maps error codes to user-friendly messages
 */
export const getErrorMessage = (error: Error): string => {
  if (error instanceof SupabaseError) {
    switch (error.code) {
      case 'AUTH_ERROR':
        return 'Authentication failed. Please check your credentials and try again.';
      case 'DATABASE_ERROR':
        return 'There was a problem accessing your data. Please try again later.';
      default:
        return error.message;
    }
  }
  return 'An unexpected error occurred. Please try again later.';
};